(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["b2b-company-marquee"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('b2b-company-marquee')) {
    class B2bCompanyMarquee extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('.b2b-marquee__viewport');
        this.track = this.querySelector('.b2b-marquee__track');

        if (!this.viewport || !this.track || !this.track.firstElementChild) return;

        this.baseCopy = this.track.firstElementChild;
        this.layout = this.layout.bind(this);

        this.resizeObserver = new ResizeObserver(this.layout);
        this.resizeObserver.observe(this.viewport);

        this.layout();

        window.addEventListener('load', this.layout);

        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(this.layout);
        }
      }

      disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
        window.removeEventListener('load', this.layout);
      }

      layout() {
        if (!this.isConnected || !this.baseCopy) return;

        // Auf eine einzelne Kopie zuruecksetzen, damit sauber gemessen werden kann.
        while (this.track.children.length > 1) {
          this.track.removeChild(this.track.lastElementChild);
        }

        const copyWidth = this.baseCopy.getBoundingClientRect().width;
        const viewportWidth = this.viewport.getBoundingClientRect().width;

        if (!copyWidth) return;

        // So viele Kopien, dass die Spur immer breiter als der sichtbare Bereich ist.
        const copies = Math.max(2, Math.ceil(viewportWidth / copyWidth) + 1);

        for (let index = 1; index < copies; index++) {
          const clone = this.baseCopy.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.querySelectorAll('[data-shopify-editor-block]').forEach((node) => {
            node.removeAttribute('data-shopify-editor-block');
          });
          clone.querySelectorAll('a').forEach((link) => {
            link.setAttribute('tabindex', '-1');
          });
          this.track.appendChild(clone);
        }

        const speed = parseFloat(this.dataset.speed) || 40;

        this.track.style.setProperty('--b2b-marquee-copies', copies);
        this.track.style.setProperty('--b2b-marquee-duration', (copyWidth / speed).toFixed(2) + 's');
      }
    }

    customElements.define('b2b-company-marquee', B2bCompanyMarquee);
  }

  } catch(e) { console.error(e); }
})();
})();
